module.exports = __webpack_public_path__ + "img/vatican_road_2k.9fd7ff0b.png";